import { useBranding } from '@/shared/contexts/BrandingContext';

export default function HeaderLogo() {
  const { currentBrand } = useBranding();

  if (currentBrand.type === 'aegis360') {
    return (
      <div className="flex items-center space-x-3">
        <img 
          src="/aegis360-logo.jpg" 
          alt="Aegis360 Pest Management Solutions Logo" 
          className="h-16 w-auto hover:scale-105 transition-all duration-200"
          style={{ 
            maxHeight: '64px',
            maxWidth: '200px',
            objectFit: 'contain'
          }}
          onLoad={() => console.log('Aegis360 logo loaded successfully')}
          onError={(e) => {
            console.error('Aegis360 logo failed to load, showing fallback');
            const img = e.target as HTMLImageElement;
            img.style.display = 'none';
          }}
        />
        <div className="text-3xl">🛡️</div>
        <div>
          <h1 className="text-2xl font-bold text-blue-600">Aegis360</h1>
          <p className="text-sm text-gray-600">SaaS Platform</p>
        </div>
      </div>
    );
  }

  return (
    <img 
      src="/greenshield-logo.png" 
      alt="GREENSHIELD Pest Management Logo" 
      className="h-16 w-auto hover:scale-105 transition-all duration-200"
      style={{ 
        maxHeight: '64px',
        maxWidth: '200px',
        objectFit: 'contain'
      }}
      onError={(e) => {
        console.error('Logo failed to load:', e);
        (e.target as HTMLImageElement).style.display = 'none';
      }}
    />
  );
}